import { AlertCircle, RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

interface OAuthErrorStateProps {
  onReconnect: () => Promise<void>;
  isLoading?: boolean;
}

export default function OAuthErrorState({
  onReconnect,
  isLoading = false,
}: OAuthErrorStateProps) {
  return (
    <div className="flex flex-col items-center justify-center h-full min-h-[400px] px-4 py-8">
      <div className="max-w-md w-full text-center space-y-4">
        {/* Icon */}
        <div className="flex justify-center">
          <div className="rounded-full bg-orange-100 p-4">
            <AlertCircle className="w-8 h-8 text-orange-600" />
          </div>
        </div>

        {/* Title */}
        <div className="space-y-2">
          <h3 className="text-lg font-semibold text-gray-900">
            Facebook Session Expired
          </h3>
          <p className="text-sm text-gray-600">
            Your Facebook session has expired. Please reconnect your Facebook
            account to continue using chat features.
          </p>
        </div>

        {/* Action Button */}
        <div className="pt-2">
          <Button
            onClick={onReconnect}
            disabled={isLoading}
            className="min-w-[160px]"
          >
            {isLoading ? (
              <>
                <RefreshCw className="w-4 h-4 animate-spin" />
                Connecting...
              </>
            ) : (
              <>
                <RefreshCw className="w-4 h-4" />
                Reconnect Facebook
              </>
            )}
          </Button>
        </div>
      </div>
    </div>
  );
}

